import './permissions-table.scss';
import { TeamWithRoles } from './permissions-table.types';

export const TeamName = ({ team }: { team: TeamWithRoles }) => {
  return (
    <a
      key={team.team.id}
      href={`/organization/${team.team.team_accounts[0]?.accountId}/teams/${team.team.id}`}
    >
      {team.team.name}
    </a>
  );
};
